/*  ========================================================================
    # Scripts - Image Lightbox
    ========================================================================  */

/**
 * Script that handles basic image lightbox behavior
 */

const ImageLightbox = {
  cfg: {
    dialogs: document.querySelectorAll('.c-image-lightbox'),
    triggers: document.querySelectorAll('[data-lightbox-trigger]'),
    closeButtons: document.querySelectorAll('[data-lightbox-close]')
  },

  /**
   * Initialize.
   */
  init() {
    // Handle opening the lightboxes
    if (this.cfg.triggers.length > 0) {
      this.cfg.triggers.forEach(trigger => {
        trigger.addEventListener('click', e => {
          const dialog = document.getElementById(trigger.getAttribute('data-lightbox-trigger'));
          if (typeof dialog.showModal === 'function' && dialog instanceof HTMLDialogElement) {
            dialog.showModal();
            document.body.setAttribute('data-lightbox-open', '');
            // Now load the image source
            const img = dialog.querySelector('.c-image-lightbox__image');
            if (img && img.dataset.src) {
              img.src = img.dataset.src;
            }
          }
        });
      });
    }
    // Handle native closing of the lightboxes
    if (this.cfg.dialogs.length > 0) {
      this.cfg.dialogs.forEach(dialog => {
        dialog.addEventListener('close', () => {
          document.body.removeAttribute('data-lightbox-open');
        });
      });
    }
    // Handle closing the lightboxes
    if (this.cfg.closeButtons.length > 0) {
      this.cfg.closeButtons.forEach(button => {
        button.addEventListener('click', e => {
          const dialog = e.target.closest('dialog');
          dialog.close();
        });
      });
    }
  }
};

export default ImageLightbox;
